import * as React from 'react';

import type {ButtonVariant, ButtonSize} from 'shells/button/types';

import {Button} from '../../button/button';
import {Dialog} from '../../dialog/dialog';

type Props = {
    onConfirm: () => void;
    question: string;
    buttonText?: string; // defaults to 'Remove',
    primaryText?: string; // defaults to 'Yes, remove',
    secondaryText?: string; // defaults to 'No, don’t remove',
    buttonVariant?: ButtonVariant; // defaults to 'secondary',
    buttonSize?: ButtonSize; // defaults to 'normal',
    disabled?: boolean;
    dialogWidth?: string;
};

export function TextButtonWithConfirmation(props: Props) {
    const {
        onConfirm,
        question,
        buttonText = 'Remove',
        primaryText = 'Yes, remove',
        secondaryText = 'No, don’t remove',
        buttonVariant = 'secondary',
        buttonSize = 'normal',
        disabled = false,
        dialogWidth,
    } = props;
    const [isConfirmingRemove, setIsConfirmingRemove] = React.useState<boolean>(false);
    const removeRef = React.useRef();

    return (
        <>
            <Button
                getButtonRef={removeRef}
                onClick={() => setIsConfirmingRemove(true)}
                variant={buttonVariant}
                size={buttonSize}
                disabled={disabled}
            >
                {buttonText}
            </Button>
            {isConfirmingRemove ? (
                <Dialog
                    anchor={removeRef.current}
                    location='top'
                    question={question}
                    primaryText={primaryText}
                    secondaryText={secondaryText}
                    onPrimary={() => {
                        onConfirm();
                        setIsConfirmingRemove(false);
                    }}
                    onSecondary={() => {
                        setIsConfirmingRemove(false);
                    }}
                    isWarning={true}
                    customStyles={dialogWidth ? {width: dialogWidth} : undefined}
                />
            ) : undefined}
        </>
    );
}
